export default "__VITE_ASSET__8dE0Luof__"